export const API_BASE_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost/antellaperu/usuario"
    : "https://antellaperu.com/usuario";

export async function apiFetch(
  endpoint: string,
  options: RequestInit = {}
) {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  const text = await response.text();

  let data: any = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    console.error("❌ Respuesta no JSON:", text);
    throw new Error("Respuesta inválida del servidor");
  }

  if (!response.ok) {
    const error: any = new Error(data?.msg || "Error API");
    error.status = response.status;
    throw error;
  }

  return data;
}
